import React from "react";
import { Container } from "react-bootstrap";
import Hero from "./Hero";
import Sidebar from "./Sidebar";
import Experience from "./Experience";
import FeaturedProjects from "./FeaturedProjects";
import EduCerts from "./EduCerts";
import ContactBand from "./ContactBand";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container>
          <Hero />
          <div className="dashboard-grid">
            <Sidebar />
            <div className="content-area">
              <Experience />
              <FeaturedProjects />
              <EduCerts />
            </div>
          </div>
          <ContactBand />
        </Container>
      </Container>
    </section>
  );
}

export default Home;